// ── Inbound hub events (server → client) ─────────────────────────────────────

export interface RaceRequestEvent {
  id: string;
  nomePassageiro: string;
  celular: string;
  enderecoOrigem: string;
  enderecoDestino: string;
  latitudeOrigem: string;
  longitudeOrigem: string;
  latitudeDestino: string | null;
  longitudeDestino: string | null;
  valorCorrida: number;
  repasseMotorista: number;
  distance: number;
  raceType: string;
  vehicleType: string;
  vendedor: any;
  motorista: any;
  dataRequisicao: string;
  dataAgendamentoCorrida: string | null;
  idioma?: number[];
  porcentagem?: string;
}

export interface DriverPositionEvent {
  posicaoMotoristaFila: number;
  numeroCarrosFila: number;
  numerosCorridaDia: number;
}

export interface RaceRequestStatusPayload {
  status: number;   // StatusRequisicaoCorrida enum value from backend
  race?: RaceRequestEvent;
  raceId?: string;
}

// Union type of all hub events — enables exhaustive handling
export type HubEvent =
  | { type: 'RaceRequest';             payload: RaceRequestEvent }
  | { type: 'DriverPosition';          payload: DriverPositionEvent }
  | { type: 'OnAccept';                payload: RaceRequestEvent }
  | { type: 'OnAcceptOwnRace';         payload: RaceRequestEvent }
  | { type: 'OnAcceptOwnTour';         payload: RaceRequestEvent }
  | { type: 'CancelRaceRequest';       payload: any }
  | { type: 'CancelTrip';             payload: any }
  | { type: 'DriverKicked';           payload: boolean }
  | { type: 'VerifyConnectionStatus'; payload: boolean }
  | { type: 'RaceRequestStatus';      payload: RaceRequestStatusPayload }
  | { type: 'DriverTripsInDispute';   payload: any[] }
  | { type: 'UpcomingRaceNotification'; payload: RaceRequestEvent }
  | { type: 'DriversOnline';          payload: any[] }
  | { type: 'SellerConnectionStatus'; payload: string };

// Hub event name constants — single source of truth for string event names
export const HUB_EVENTS = {
  RACE_REQUEST:           'RaceRequest',
  DRIVER_POSITION:        'DriverPosition',
  ON_ACCEPT:              'OnAccept',
  ON_ACCEPT_OWN_RACE:     'OnAcceptOwnRace',
  ON_ACCEPT_OWN_TOUR:     'OnAcceptOwnTour',
  CANCEL_RACE_REQUEST:    'CancelRaceRequest',
  CANCEL_TRIP:            'CancelTrip',
  DRIVER_KICKED:          'DriverKicked',
  VERIFY_CONNECTION:      'VerifyConnectionStatus',
  RACE_REQUEST_STATUS:    'RaceRequestStatus',
  DRIVER_TRIPS_DISPUTE:   'DriverTripsInDispute',
  UPCOMING_RACE:          'UpcomingRaceNotification',
  DRIVERS_ONLINE:         'DriversOnline',
  SELLER_STATUS:          'SellerConnectionStatus',
} as const;

// Hub method names — single source of truth for invoke strings
export const HUB_METHODS = {
  CONNECT_DRIVER_ENTER_LINE:   'ConnectDriverAndEnterInLine',
  RECONNECT_DRIVER:            'ReconnectDriver',
  CONNECT_DRIVER_ONLY:         'ConnectDriverOnly',
  LEAVE_LINE:                  'LeaveLine',
  CONNECT_SELLER:              'ConnectSeller',
  NEW_RACE_REQUEST:            'NewRaceRequest',
  NEW_TOUR_REQUEST:            'NewTourRequest',
  NEW_RACE_REQUEST_DRIVER:     'NewRaceRequestDriver',
  NEW_TOUR_REQUEST_DRIVER:     'NewTourRequestDriver',
  ACCEPT_RACE:                 'AcceptRace',
  ACCEPT_TOUR:                 'AcceptTour',
  REFUSE_RACE:                 'RefuseRace',
  CLEAR_RACE_REQUEST:          'ClearRaceRequest',
  KICK_DRIVER:                 'KickDriver',
  CHECK_CONNECTION:            'CheckConnection',
  TRIPS_IN_DISPUTE_DRIVER:     'TripsInDisputeDriver',
  ENTER_QUEUE_RULE_VALIDATION: 'EnterQueueRuleValidation',
  COUNTDOWN_TO_ACCEPT:         'CountdownToAccept',
} as const;
